import React from 'react';
import Login from '../Login';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Authentication from '../Authentication';

const auth = new Authentication();

export const LoginRoute = () => {
  // const dispatch = useDispatch();
  const login = useSelector(state => state.login);
  const [redirect, setRedirect] = React.useState(login.loggedIn);
  const url = '/';

  React.useEffect(() => {
    setRedirect(login.loggedIn);
  }, [login]);

  return (
    <React.Fragment>
      {redirect && <Redirect to={url} />}
      <Login auth={auth} />
    </React.Fragment>
  );
};